import { CONFIG } from 'app/core/config';
import { ViewModel } from '../view-model';

export class LookupDisplayValue implements ViewModel {
  readonly friendlyTypeNameSingular = 'Lookup Display Value';
  readonly apiRoute: string = CONFIG.apiRoutes.lookupDisplayValue;
  lookupId: string;
  lookupRowId: string;
  rowIndex: number;
  displayValue: string;

  json() {
    return this;
  }

  loadFromJson(data) {
    this.lookupId = data.lookupId;
    this.lookupRowId = data.lookupRowId;
    this.rowIndex = data.rowIndex;
    this.displayValue = data.displayValue;
  }
}
